<script setup lang="ts">
import SmartSearchTabs from '@/components/tabs/SmartSearchTabs.vue';
import SearchVWindow from '@/components/vWindows/SearchVWindow.vue';
</script>

<template>
  <div :class="$style.barsSearchLayoutView">
    <div class="d-flex">
      <SmartSearchTabs :class="$style.searchTabs" />
    </div>
    <SearchVWindow :class="$style.windowItems" />
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.barsSearchLayoutView {
}
  .searchTabs {
    margin: 1rem variables.$pageMarginX 0 variables.$pageMarginX;
  }
  .windowItems {
    overflow: visible;
  }
</style>
